<template>
  <div class="container">
    <div class="jl-tips-shadow"></div>
    <div class="jl-order-search clearfix">
      <p class="text-title">我的订单</p>
      <div class="search-box" @keyup.enter="preSearch">
        <input
          type="text"
          v-model.trim="keyword"
          placeholder="请输入订单编号"
        />
        <i class="search-icon jl-icon-search" @click="preSearch"></i>
      </div>
    </div>
    <div class="jl-order-list-wrapper">
      <div v-loading="isloading" class="jl-loading-box">
        <div class="jl-com-nodata-tips" v-if="nodata">
          <div class="jl-com-nodata-box">
            <i class="jl-icon-74wodedingdan"></i>
            <p class="text">暂无订单相关记录！</p>
            <!-- <p class="text-tips-btn" @click="gotoshop">逛一逛</p> -->
          </div>
        </div>
        <div
          class="jl-order-list-item"
          v-for="(item, index) in orderData"
          :key="'order-' + index"
        >
          <div class="jl-order-list-item-head">
            <span>订单编号：{{ item.id }}</span>
            <span>下单时间：{{ item.creatDate }}</span>
          </div>
          <div class="jl-order-list-item-box">
            <div class="jl-order-list-item-goods">
              <ul>
                <li
                  v-for="(good, i) in item.orderGoodsInfoList"
                  :key="'order-goods-' + i"
                >
                  <div class="jl-order-list-item-goods-one">
                    <div class="jl-order-list-item-goods-img">
                      <img :src="good.imgsUrl" />
                    </div>
                    <div class="jl-order-list-item-goods-intro">
                      <p
                        class="jl-order-list-item-goods-name"
                        @click="goToShopDetail(good, item)"
                      >
                        {{ good.name }}
                      </p>
                      <p class="text3" v-if="good.series">
                        系列：{{ good.series }} / 颗粒：{{ good.particles }} /
                        包装：{{ good.pack }}
                      </p>
                      <p class="text3" v-else-if="good.specification">
                        规格：{{ good.specification }}
                      </p>
                      <p>￥{{ good.price }}</p>
                    </div>
                    <div class="jl-order-list-item-goods-num">
                      X {{ good.number }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="jl-order-list-item-status">
              <p class="text-status blue" v-if="item.orderStatus === 1">
                待发货
              </p>
              <p class="text-status blue" v-if="item.orderStatus === 3">
                已发货
              </p>
              <p class="text-status" v-if="item.orderStatus === 2">未付款</p>
              <p class="text-status" v-if="item.orderStatus === 0">逾期</p>
              <p v-if="item.orderStatus === 3 && item.receiveWay !== 0">
                <a @click="lookLogistics(item.id)">查看物流</a>
              </p>
            </div>
            <div class="jl-order-list-item-amount">
              <p>￥{{ item.orderPrice }}</p>
              <p v-if="item.receiveWay === 0">(商品自提)</p>
              <!-- <p v-if="item.receiveWay !== 0 && item.orderStatus === 1">(含运费：￥{{ item.freight }})</p> -->
              <p v-if="item.payMethod === 0">在线支付</p>
              <p v-if="item.payMethod === 1">货到付款</p>
              <p v-if="item.payMethod === 2">微信转账</p>
            </div>
            <div class="jl-order-list-item-op">
              <button
                v-if="item.orderStatus === 2 && item.payMethod !== 2"
                @click="payOrder(item)"
              >
                立即付款
              </button>
              <a @click="goToDetail(item.id)">订单详情</a>
              <!--  <a
              href="javascript:void(0)"
              class="jl-order-gray-font"
              v-if="item.orderStatus === 2 && item.orderGoodsType === 1"
              @click="cancelOrder(item.id, index)"
              >取消订单</a>-->
              <a
                href="javascript:void(0)"
                class="jl-order-gray-font"
                v-if="item.orderStatus === 2 && item.orderGoodsType === 1"
                @click="cancelOrder(item.id, index)"
                >取消订单</a
              >
              <a
                href="javascript:void(0)"
                class="jl-order-gray-font"
                v-if="item.orderStatus === 1 && item.orderGoodsType !== 0"
                @click="buyAgain(item.id)"
                >再次购买</a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="jl-page-box clearfix" v-if="orderData.length > 0">
        <div style="float: right">
          <v-pagination
            :total="total"
            :display="display"
            :currentPage="current"
            @pagechange="pagechange"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getOrderList, cancelOrder, onceAgain } from '../../api/order';
import Pagination from '@/components/Pagination';
export default {
  name: 'orderList',
  components: {
    'v-pagination': Pagination
  },
  data() {
    return {
      keyword: '',
      orderData: [],
      total: 1,
      display: 10,
      current: 1,
      afterCancelOrderType: false,
      isloading: true,
      nodata: false
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.initData();
  },
  methods: {
    gotoshop() {
      this.$router.push({
        name: 'shopIndex'
      });
    },
    //查看物流
    lookLogistics(id) {
      this.$router.push({
        name: 'accountOrderLogistics',
        params: {
          id: id
        }
      });
    },
    pagechange(idx) {
      window.scrollTo(0, 0);
      this.current = idx;
      getOrderList(this);
      window.scrollTo(0, 0);
    },
    initData() {
      //order_goods_type` int(1) DEFAULT NULL COMMENT '0 拍卖订单 1商品订单',
      //order_status'订单状态 0 逾期 1 已支付 2未支付',
      //receiveWay '收货方式 0 自提  1 快递',
      //pay_method付款方式   0在线支付 1 货到付款 2微信转账
      //pay_type支付类型 0 支付宝 1 微信
      getOrderList(this);
    },
    preSearch($event) {
      this.afterCancelOrderType = false;
      this.searchOrder();
    },
    searchOrder() {
      this.current = 1;
      getOrderList(this);
    },
    payOrder(item) {
      //orderGoodsType '0 拍卖订单 1商品订单
      //console.log(item);
      let totalprice = 0;
      let list = item.orderGoodsInfoList.map(el => {
        if (item.orderGoodsType === 0) {
          totalprice = parseFloat(el.price);
        } else {
          totalprice += parseFloat(el.totalPrice);
        }

        el.goods = {
          name: el.name,
          auctionId: item.auctionId
        };
        return el;
      });
      let data = {
        totalPrice: totalprice,
        waitPaidPrice: item.waitPaidPrice,
        list: list
      };
      //console.log(data);
      this.$store.dispatch('saveCartItemData', data);
      if (item.orderGoodsType === 0) {
        if (item.logisticsAddressId) {
          this.$router.push({
            name: 'orderPay',
            params: {
              id: item.id
            }
          });
        } else {
          this.$router.push({
            path: '/auction/detail/order',
            query: {
              id: item.id,
              orderGoodsType: item.orderGoodsType
            }
          });
        }
      } else if (item.orderGoodsType === 1) {
        this.$router.push({
          name: 'orderPay',
          params: {
            id: item.id
          }
        });
      }
    },
    goToDetail(orderId) {
      this.$router.push({
        path: '/account/order/detail/' + orderId
      });
    },
    cancelOrder(orderId, index) {
      this.$confirm('是否确认取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cancelOrder(this, orderId, res => {
            if (res.code === 200) {
              if (this.current > 1) {
                this.afterCancelOrderType = true;
                if (this.orderData.length === 0) {
                  this.current--;
                }
              }
              getOrderList(this);
            }
          });
        })
        .catch(() => {});

      // this.$loginBox();
    },
    buyAgain(orderId) {
      onceAgain(this, orderId);
    },
    //跳转商品详情
    goToShopDetail(good, item) {
      //console.log(good);
      if (item.orderGoodsType == 1) {
        this.$router.push({
          path: '/shop/detail',
          query: {
            id: good.goodsId
          }
        });
      } else {
        this.$router.push({
          path: '/auction/detail',
          query: {
            id: good.id
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-order-list-item-status,
.jl-order-list-item-amount,
.jl-order-list-item-op {
  text-align: center;
}
.jl-order-search {
  max-width: 1200px;
  height: 45px;
  margin: 30px auto;
  text-align: left;
  position: relative;

  .text-title {
    float: left;
    font-size: 28px;
    color: #333;
    text-align: left;
    border-left: 4px solid #e70819;
    line-height: 28px;
    text-indent: 10px;
    position: absolute;
    left: 0;
    top: 8px;
  }

  .search-box {
    float: right;
    position: relative;
    .search-icon {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
      cursor: pointer;
    }
    input {
      height: 43px;
      width: 312px;
      border: 1px solid #e0e0e0;
      background: #f8f8fb;
      border-radius: 4px;
      font-size: 18px;
      color: #333;
      outline: 0;
      padding: 0 46px 0 20px;
    }
  }
}
.jl-order-list-wrapper {
  max-width: 1200px;
  padding-bottom: 120px;
  margin: 0 auto;
  min-height: 400px;

  .jl-order-list-item {
    margin-bottom: 30px;

    .jl-order-list-item-head {
      background: #f6f6f6;
      height: 40px;
      border: 1px solid #e0e0e0;
      font-size: 14px;
      color: #333;
      line-height: 40px;
      display: inline-block;
      vertical-align: top;
      width: 100%;

      span:first-child {
        float: left;
        margin-left: 20px;
      }
      span:last-child {
        float: right;
        margin-right: 20px;
      }
    }
    .jl-order-list-item-box {
      border-left: 1px solid #e0e0e0;
      min-height: 148px;
      display: table;
      width: 100%;
      font-weight: 500;

      & > div {
        display: table-cell;
        vertical-align: top;
      }
      .jl-order-list-item-goods {
        width: 578px;
        border-bottom: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        li {
          border-top: none;
          border-left: none;
          padding: 19px 19px 20px 20px;
          border-bottom: 1px solid #e0e0e0;
          &:last-child {
            border-bottom: none;
          }
          .jl-order-list-item-goods-one {
            text-align: left;
            position: relative;

            & > div {
              display: inline-block;
              vertical-align: top;
            }
            .jl-order-list-item-goods-img {
              width: 80px;
              // height: 106px;
              margin-right: 20px;

              img {
                display: block;
                width: 100%;
                // height: 100%;
              }
            }
            .jl-order-list-item-goods-intro {
              position: relative;
              width: 378px;
              height: 106px;
              overflow: hidden;

              p {
                font-size: 14px;
                color: #666;
                line-height: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-top: 10px;
              }
              p:first-child {
                font-size: 18px;
                color: #333;
                line-height: 24px;
                max-height: 48px;
                overflow: hidden;
                margin: 0;
                white-space: normal;
              }
              p:last-child {
                position: absolute;
                left: 0;
                bottom: 8px;
                margin: 0;
              }
            }
            .jl-order-list-item-goods-num {
              font-size: 14px;
              color: #666;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        }
      }
      .jl-order-list-item-status {
        width: 208px;
        border: 1px solid #e0e0e0;
        border-left: none;
        border-top: none;
        padding-top: 20px;
        font-size: 0;

        p {
          font-size: 14px;
          line-height: 14px;
          text-align: center;
        }
        p.text-status {
          position: relative;
          display: inline-block;
          padding-left: 14px;
          color: #e70819;
          margin-bottom: 20px;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            width: 8px;
            height: 8px;
            border-radius: 4px;
            margin-top: -4px;
            background: #e70819;
          }
          &.blue {
            color: #1480ff;
            &::before {
              background: #1480ff;
            }
          }
        }
        p:last-child > a {
          color: #333;
        }
      }
      .jl-order-list-item-amount {
        width: 208px;
        border: 1px solid #e0e0e0;
        border-left: none;
        border-top: none;
        padding-top: 20px;
        font-size: 0;

        p {
          font-size: 14px;
          line-height: 14px;
          color: #999;
          margin-bottom: 10px;
        }
        p:first-child {
          color: #333;
        }
      }
      .jl-order-list-item-op {
        width: 208px;
        border: 1px solid #e0e0e0;
        border-left: none;
        border-top: none;
        font-size: 0;
        padding-top: 20px;
        button {
          display: block;
          width: 84px;
          height: 32px;
          background-color: #e70819;
          color: #fff;
          font-size: 14px;
          margin: 0 auto;
          margin-bottom: 15px;
          cursor: pointer;
        }
        a {
          font-size: 14px;
          color: #333;
          display: block;
          line-height: 14px;
          margin-bottom: 15px;

          &.jl-order-gray-font {
            color: #999;
          }
        }
      }
    }
  }
}

.text-tips-btn {
  display: inline-block;
  width: 100px;
  height: 32px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #e70819;
  line-height: 32px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 40px;
}

.jl-order-list-item-goods-name {
  cursor: pointer;
}
</style>
